import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<mask id=\"mask0_sn\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"20\" height=\"20\"><circle cx=\"10\" cy=\"10\" r=\"10\" fill=\"#D9D9D9\"></circle></mask><g mask=\"url(#mask0_sn)\"><rect width=\"6.67\" height=\"20\" fill=\"#00853F\"></rect><rect x=\"6.67\" width=\"6.67\" height=\"20\" fill=\"#FDEF42\"></rect><rect x=\"13.33\" width=\"6.67\" height=\"20\" fill=\"#E31E24\"></rect><path d=\"M 10 7.5 L 10.6 9.2 L 12.3 9.2 L 10.9 10.3 L 11.5 12 L 10 10.9 L 8.5 12 L 9.1 10.3 L 7.7 9.2 L 9.4 9.2 Z\" fill=\"#00853F\"></path></g>", 2)
  ])))
}
export default { render: render }